export const CheckoutBackordersInfo = () => (
  <p className="mb-2">
    <span className="textRed">Note 1</span>: If you have backorders we will
    generate two orders: one for the existing DIDs and another one for the
    backorder. The backorder price and other commercial conditions may vary from
    the conditions stated above and in the pricelist. If price or conditions
    differ from what is shown, you will be contacted by our support team.
  </p>
);
